import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { CandidatoService } from '../../candidato/candidato.service';
import { ActivatedRoute } from '@angular/router';
import { SigopServiceService } from '../../../services/sigop-service.service';
import { CandidatoCursoEspecializadoService } from '../../../services/candidato-curso-especializado.service';
import { ConfirmationService } from 'primeng/primeng';

@Component({
  selector: 'emprego-na-pistagerenciar-cadastro-curso-pratico',
  templateUrl: './gerenciar-cadastro-curso-pratico.component.html',
  styleUrls: ['./gerenciar-cadastro-curso-pratico.component.css']
})
export class GerenciarCadastroCursoPraticoComponent extends WebPage
  implements OnInit {
  idCandidato;
  candidato;
  cursosCandidato;

  constructor(
    messageService: MessageService,
    private candidatoService: CandidatoService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private sigopServiceService: SigopServiceService,
    private candidatoCursoEspecializadoService: CandidatoCursoEspecializadoService
  ) {
    super(messageService);
    this.route.paramMap.subscribe(
      params => (this.idCandidato = params.get('idCandidato'))
    );
  }

  ngOnInit() {
    this.carregarCandidato();
    this.carregarCursosCandidato();
  }

  carregarCandidato() {
    this.isLoading = true;
    this.candidatoService
      .getFull(this.idCandidato)
      .finally(() => (this.isLoading = false))
      .subscribe(
        candidato => {
          this.candidato = candidato;
          console.log(candidato);
        },
        error => this.gerenciaErro(error)
      );
  }

  carregarCursosCandidato() {
    this.isLoading = true;
    this.sigopServiceService
      .getByIdAndTurma(this.idCandidato)
      .finally(() => (this.isLoading = false))
      .subscribe(
        cursosCandidato => {
          this.cursosCandidato = cursosCandidato;
          console.log(cursosCandidato);
        },
        error => this.gerenciaErro(error)
      );
  }

  removerCurso(id: string) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir este registro?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.candidatoCursoEspecializadoService
          .removeCandidatoCurso(id)
          .finally(() => (this.isLoading = false))
          .subscribe(
            candidato => {
              this.carregarCursosCandidato();
            },
            error => this.gerenciaErro(error)
          );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cursoPratico/gerenciar-cadastro-curso-pratico/gerenciar-cadastro-curso-pratico.component.ts